var FilterCalendar = function() {

	var comp = $('[data-component="filter-calendar"]');

	this.init = function() {

		datepicker();

	}

	function datepicker() {

		$.datepicker.regional[ "pt-BR" ] = {
			closeText: "Fechar",
			prevText: "&#x3C;Anterior",
			nextText: "Próximo&#x3E;",
			currentText: "Hoje",
			monthNames: [ "Janeiro","Fevereiro","Março","Abril","Maio","Junho",
			"Julho","Agosto","Setembro","Outubro","Novembro","Dezembro" ],
			monthNamesShort: [ "Jan","Fev","Mar","Abr","Mai","Jun",
			"Jul","Ago","Set","Out","Nov","Dez" ],
			dayNames: [
				"Domingo",
				"Segunda-feira",
				"Terça-feira",
				"Quarta-feira",
				"Quinta-feira",
				"Sexta-feira",
				"Sábado"
			],
			dayNamesShort: [ "Dom","Seg","Ter","Qua","Qui","Sex","Sáb" ],
			dayNamesMin: [ "Dom","Seg","Ter","Qua","Qui","Sex","Sáb" ],
			weekHeader: "Sm",
			dateFormat: "dd/mm/yy",
			firstDay: 0,
			isRTL: false,
			showMonthAfterYear: false,
			yearSuffix: ""
		};
		$.datepicker.setDefaults( $.datepicker.regional[ "pt-BR" ] );
		comp.find('#datepicker').on('click', function() {
			$(this).datepicker({
				autoClose: true,
				changeMonth: true,
        changeYear: true,
        showButtonPanel: false,
        dateFormat: 'MM yy',
				onSelect: function(dateText, inst) {
		      var time = dateText;
		      time = time.split('/');
		      comp.find('.month').val(time[1]);
		      comp.find('.year').val(time[2]);
		      $(this).datepicker( "destroy" );
		      $(this).html('<span class="icon-calendar"></span>');
		  	}
			});
		});
	}

	return this.init();

}

